import './bootstrap';


// import 'lity';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
window.Alpine = Alpine;

Alpine.plugin(focus);

Alpine.start();

import 'flowbite/dist/flowbite.js'
import 'flowbite/dist/datepicker.js'

// import 'sortable-tablesort/sortable.min.css'
import 'sortable-tablesort/sortable.min.js'

import moment from 'moment';
window.moment = moment

var themeToggleDarkIcon = document.getElementById('theme-toggle-dark-icon');
var themeToggleLightIcon = document.getElementById('theme-toggle-light-icon');

// Change the icons inside the button based on previous settings
if (localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    themeToggleLightIcon.classList.remove('hidden');
} else {
    themeToggleDarkIcon.classList.remove('hidden');
}

var themeToggleBtn = document.getElementById('theme-toggle');

themeToggleBtn.addEventListener('click', function () {

    // toggle icons inside button
    themeToggleDarkIcon.classList.toggle('hidden');
    themeToggleLightIcon.classList.toggle('hidden');

    // if set via local storage previously
    if (localStorage.getItem('color-theme')) {
        if (localStorage.getItem('color-theme') === 'light') {
            document.documentElement.classList.add('dark');
            localStorage.setItem('color-theme', 'dark');
        } else {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('color-theme', 'light');
        }

        // if NOT set via local storage previously
    } else {
        if (document.documentElement.classList.contains('dark')) {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('color-theme', 'light');
        } else {
            document.documentElement.classList.add('dark');
            localStorage.setItem('color-theme', 'dark');
        }
    }

});


/**
 *  disable submit button after form submit
 */
// Get all the forms on the page
const forms = document.getElementsByTagName('form');

// Add an event listener to the submit event of each form
for (let i = 0; i < forms.length; i++) {
    forms[i].addEventListener('submit', function(event) {
        // Check if the form can be submitted
        if (this.hasAttribute('data-submitted')) {
            // Form has already been submitted, prevent further submissions
            event.preventDefault();
        } else {
            // Set an attribute to mark the form as submitted
            this.setAttribute('data-submitted', 'true');
        }
    });
}
